export const Languages = [
    { id: 'en', name: 'English' },
    { id: 'ar', name: 'العربية' },
    { id: 'pt-BR', name: 'Português (Brasil)' }
];

const translations = {
    en: {
        common: {
            language: 'Language',
            yes: 'Yes',
            no: 'No',
            refresh: 'Refresh',
            reset: 'Reset',
            offline: 'Offline',
            offlineHint: 'Looks like you are no longer connected to the Internet. No worries. AzanClock will still work.',
            at: '@',
            am: 'A',
            pm: 'P'
        },
        menu: {
            settings: 'Settings',
            recitations: 'Qur\'an Recitations',
            alarms: 'Alarms',
            about: 'About',
            close: 'Close'
        },
        settings: {
            ramadanTipTitle: 'Ramadan Tip:',
            ramadanTipBody: 'Many people add a few extra minutes to the Maghrib offset during Ramadan to ensure sunset has fully occurred. May Allah accept all our fasting.',
            location: 'Set Your Location',
            locationPlaceholder: 'Enter any address or location',
            locationUpdated: 'Your location is updated.',
            locationNotFound: 'Couldn\'t find that location. Please try again.',
            locationOffline: 'Couldn\'t find that location. Please make sure you are connected to Internet and try again.',
            mapTitle: 'See location on Google Maps',
            calculationMethod: 'Calculation Method',
            asrCalculationMethod: 'Asr Calculation Method',
            displayMode: 'Display Mode',
            screenSaverMode: 'Screen Saver Mode',
            zoomedInMode: 'Zoomed In Mode',
            enableAzanCalls: 'Enable Azan Calls & Alarms',
            azan: 'Azan',
            minuteOffset: 'Minute Offset',
            imsak: 'Imsak',
            duha: 'Duha',
            midnight: 'Midnight'
        },
        clock: {
            elapsed: 'Elapsed',
            next: 'Next',
            in: 'in',
            remainingUntil: ''
        },
        options: {
            auto: 'Auto',
            normal: 'Normal',
            dim: 'Dim',
            standard: 'Standard',
            hanafi: 'Hanafi Late Asr'
        },
        themes: {
            label: 'Display Theme',
            classic: 'Classic',
            noir: 'Noir',
            emerald: 'Emerald',
            minimal: 'Minimal'
        },
        layouts: {
            label: 'Display Layout',
            clock: 'Circular Clock',
            dashboard: 'Prayer Dashboard'
        },
        dashboard: {
            gregorian: 'Gregorian',
            hijri: 'Hijri',
            current: 'Current',
            next: 'Next',
            now: 'Now',
            currentPrayer: 'Current prayer',
            prayerWindow: 'Prayer window',
            night: 'Night',
            lastThird: 'Last third',
            daysLeft: 'days left',
            ramadan: 'Ramadan',
            eidFitr: 'Eid al-Fitr',
            eidAdha: 'Eid al-Adha',
            todayPrayers: 'Today\'s prayers'
        },
        recitations: {
            title: 'Qur\'an Recitations',
            surahPrefix: 'Surah',
            by: 'by',
            source: 'mp3Quran.net',
            startMsg: 'Recitation by {reciter} will begin in about 3 seconds inshaAllah.',
            reciterMaher: 'Shaykh Maher Al-Muaiqly',
            surahs: {
                '018': 'Al-Kahf',
                '032': 'Al-Sajdah',
                '036': 'YaSin',
                '067': 'Al-Mulk',
                '076': 'Al-Insan',
                '078': 'An-Naba'
            }
        },
        prayers: {
            Fajr: 'Fajr',
            Sunrise: 'Sunrise',
            Imsak: 'Imsak',
            Duha: 'Duha',
            Duhaend: 'Duha',
            Dhuhr: 'Dhuhr',
            Asr: 'Asr',
            Maghrib: 'Maghrib',
            Isha: 'Isha'
        },
        about: {
            greeting: 'As Salamu Alaykum',
            intro: 'Use AzanClock.com to turn any Android, Amazon Echo or Raspberry Pi device into an actual azan clock.',
            free: 'Free, safe and open source.',
            noSignup: 'No registrations or subscriptions.',
            offline: 'Works even when offline.',
            androidTitle: 'Android or RPi Devices',
            androidBody: 'Add azanclock.com to your home screen and run it.',
            echoTitle: 'Amazon Echo Devices',
            echoBody: 'Say, "Alexa, open Silk browser", navigate to azanclock.com and click on the button to keep it always ON.',
            deviceSuggestions: 'Device suggestions',
            zakatText: 'Calculate and Track Your Zakat Easily',
            privacy: 'Privacy Policy',
            source: 'Open Source Code',
            chrome: 'Prayer Times Chrome Extension'
        }
    },
    ar: {
        common: {
            language: 'اللغة',
            yes: 'نعم',
            no: 'لا',
            refresh: 'تحديث',
            reset: 'إعادة ضبط',
            offline: 'بدون اتصال',
            offlineHint: 'يبدو أنك غير متصل بالإنترنت الآن. لا تقلق، سيستمر AzanClock في العمل.',
            at: 'في',
            am: 'ص',
            pm: 'م'
        },
        menu: {
            settings: 'الإعدادات',
            recitations: 'تلاوات القرآن',
            alarms: 'التنبيهات',
            about: 'عن التطبيق',
            close: 'إغلاق'
        },
        settings: {
            ramadanTipTitle: 'تنبيه رمضان:',
            ramadanTipBody: 'كثير من الناس يضيفون دقائق قليلة إلى أذان المغرب في رمضان للتأكد من دخول وقت الغروب. تقبل الله منا ومنكم الصيام.',
            location: 'حدد موقعك',
            locationPlaceholder: 'اكتب العنوان أو المدينة',
            locationUpdated: 'تم تحديث موقعك.',
            locationNotFound: 'لم نتمكن من العثور على هذا الموقع. حاول مرة أخرى.',
            locationOffline: 'لم نتمكن من العثور على الموقع. تأكد من اتصالك بالإنترنت ثم حاول مرة أخرى.',
            mapTitle: 'عرض الموقع على خرائط Google',
            calculationMethod: 'طريقة حساب المواقيت',
            asrCalculationMethod: 'طريقة حساب العصر',
            displayMode: 'وضع العرض',
            screenSaverMode: 'وضع حماية الشاشة',
            zoomedInMode: 'وضع التكبير',
            enableAzanCalls: 'تفعيل الأذان والتنبيهات',
            azan: 'الأذان',
            minuteOffset: 'فرق الدقائق',
            imsak: 'الإمساك',
            duha: 'الضحى',
            midnight: 'منتصف الليل'
        },
        clock: {
            elapsed: 'مضى',
            next: 'التالي',
            in: 'بعد',
            remainingUntil: 'يتبقى على'
        },
        options: {
            auto: 'تلقائي',
            normal: 'عادي',
            dim: 'خافت',
            standard: 'قياسي',
            hanafi: 'حنفي - عصر متأخر'
        },
        themes: {
            label: 'ثيم العرض',
            classic: 'كلاسيكي',
            noir: 'ليلي',
            emerald: 'زمردي',
            minimal: 'هادئ'
        },
        layouts: {
            label: 'نظام العرض',
            clock: 'ساعة دائرية',
            dashboard: 'لوحة المواقيت'
        },
        dashboard: {
            gregorian: 'ميلادي',
            hijri: 'هجري',
            current: 'الحالي',
            next: 'التالي',
            now: 'الآن',
            currentPrayer: 'الصلاة الحالية',
            prayerWindow: 'وقت الصلاة',
            night: 'الليل',
            lastThird: 'الثلث الأخير',
            daysLeft: 'يوم متبقي',
            ramadan: 'رمضان',
            eidFitr: 'عيد الفطر',
            eidAdha: 'عيد الأضحى',
            todayPrayers: 'صلوات اليوم'
        },
        recitations: {
            title: 'تلاوات القرآن',
            surahPrefix: 'سورة',
            by: 'بصوت',
            source: 'mp3Quran.net',
            startMsg: 'ستبدأ تلاوة {reciter} خلال حوالي 3 ثوانٍ إن شاء الله.',
            reciterMaher: 'الشيخ ماهر المعيقلي',
            surahs: {
                '018': 'الكهف',
                '032': 'السجدة',
                '036': 'يس',
                '067': 'الملك',
                '076': 'الإنسان',
                '078': 'النبأ'
            }
        },
        prayers: {
            Fajr: 'الفجر',
            Sunrise: 'الشروق',
            Imsak: 'الإمساك',
            Duha: 'الضحى',
            Duhaend: 'الضحى',
            Dhuhr: 'الظهر',
            Asr: 'العصر',
            Maghrib: 'المغرب',
            Isha: 'العشاء'
        },
        about: {
            greeting: 'السلام عليكم',
            intro: 'استخدم AzanClock.com لتحويل أي جهاز أندرويد أو Amazon Echo أو Raspberry Pi إلى ساعة أذان حقيقية.',
            free: 'مجاني وآمن ومفتوح المصدر.',
            noSignup: 'لا يحتاج إلى تسجيل أو اشتراكات.',
            offline: 'يعمل حتى بدون اتصال بالإنترنت.',
            androidTitle: 'أجهزة Android أو Raspberry Pi',
            androidBody: 'أضف azanclock.com إلى الشاشة الرئيسية ثم شغله.',
            echoTitle: 'أجهزة Amazon Echo',
            echoBody: 'قل: "Alexa, open Silk browser"، ثم افتح azanclock.com واضغط على زر إبقاء الشاشة تعمل دائمًا.',
            deviceSuggestions: 'اقتراحات أجهزة',
            zakatText: 'احسب زكاتك وتابعها بسهولة',
            privacy: 'سياسة الخصوصية',
            source: 'الكود مفتوح المصدر',
            chrome: 'إضافة مواقيت الصلاة لمتصفح Chrome'
        }
    },
    'pt-BR': {
        common: {
            language: 'Idioma',
            yes: 'Sim',
            no: 'Não',
            refresh: 'Atualizar',
            reset: 'Redefinir',
            offline: 'Offline',
            offlineHint: 'Parece que você não está mais conectado à internet. Sem problemas, o AzanClock continuará funcionando.',
            at: 'às',
            am: 'AM',
            pm: 'PM'
        },
        menu: {
            settings: 'Configurações',
            recitations: 'Recitações do Alcorão',
            alarms: 'Alarmes',
            about: 'Sobre',
            close: 'Fechar'
        },
        settings: {
            ramadanTipTitle: 'Dica do Ramadan:',
            ramadanTipBody: 'Muitas pessoas adicionam alguns minutos ao ajuste do Maghrib durante o Ramadan para garantir que o pôr do sol já ocorreu. Que Allah aceite nosso jejum.',
            location: 'Defina sua localização',
            locationPlaceholder: 'Digite qualquer endereço ou local',
            locationUpdated: 'Sua localização foi atualizada.',
            locationNotFound: 'Não foi possível encontrar esse local. Tente novamente.',
            locationOffline: 'Não foi possível encontrar esse local. Verifique sua conexão com a internet e tente novamente.',
            mapTitle: 'Ver localização no Google Maps',
            calculationMethod: 'Método de cálculo',
            asrCalculationMethod: 'Método de cálculo do Asr',
            displayMode: 'Modo de exibição',
            screenSaverMode: 'Modo protetor de tela',
            zoomedInMode: 'Modo ampliado',
            enableAzanCalls: 'Ativar chamadas do azan e alarmes',
            azan: 'Azan',
            minuteOffset: 'Ajuste em minutos',
            imsak: 'Imsak',
            duha: 'Duha',
            midnight: 'Meia-noite'
        },
        clock: {
            elapsed: 'Decorrido',
            next: 'Próximo',
            in: 'em',
            remainingUntil: ''
        },
        options: {
            auto: 'Automático',
            normal: 'Normal',
            dim: 'Escuro',
            standard: 'Padrão',
            hanafi: 'Hanafi - Asr tardio'
        },
        themes: {
            label: 'Tema da tela',
            classic: 'Clássico',
            noir: 'Noir',
            emerald: 'Esmeralda',
            minimal: 'Minimalista'
        },
        layouts: {
            label: 'Layout da tela',
            clock: 'Relógio circular',
            dashboard: 'Painel de orações'
        },
        dashboard: {
            gregorian: 'Gregoriano',
            hijri: 'Hijri',
            current: 'Atual',
            next: 'Próximo',
            now: 'Agora',
            currentPrayer: 'Oração atual',
            prayerWindow: 'Período da oração',
            night: 'Noite',
            lastThird: 'Último terço',
            daysLeft: 'dias restantes',
            ramadan: 'Ramadan',
            eidFitr: 'Eid al-Fitr',
            eidAdha: 'Eid al-Adha',
            todayPrayers: 'Orações de hoje'
        },
        recitations: {
            title: 'Recitações do Alcorão',
            surahPrefix: 'Surata',
            by: 'por',
            source: 'mp3Quran.net',
            startMsg: 'A recitação por {reciter} começará em cerca de 3 segundos, inshaAllah.',
            reciterMaher: 'Sheikh Maher Al-Muaiqly',
            surahs: {
                '018': 'Al-Kahf',
                '032': 'As-Sajdah',
                '036': 'YaSin',
                '067': 'Al-Mulk',
                '076': 'Al-Insan',
                '078': 'An-Naba'
            }
        },
        prayers: {
            Fajr: 'Fajr',
            Sunrise: 'Nascer do sol',
            Imsak: 'Imsak',
            Duha: 'Duha',
            Duhaend: 'Duha',
            Dhuhr: 'Dhuhr',
            Asr: 'Asr',
            Maghrib: 'Maghrib',
            Isha: 'Isha'
        },
        about: {
            greeting: 'As-salamu alaykum',
            intro: 'Use AzanClock.com para transformar qualquer dispositivo Android, Amazon Echo ou Raspberry Pi em um relógio de azan real.',
            free: 'Gratuito, seguro e de código aberto.',
            noSignup: 'Sem cadastro ou assinatura.',
            offline: 'Funciona mesmo offline.',
            androidTitle: 'Dispositivos Android ou Raspberry Pi',
            androidBody: 'Adicione azanclock.com à tela inicial e execute o app.',
            echoTitle: 'Dispositivos Amazon Echo',
            echoBody: 'Diga "Alexa, open Silk browser", acesse azanclock.com e clique no botão para manter a tela sempre ligada.',
            deviceSuggestions: 'Sugestões de dispositivos',
            zakatText: 'Calcule e acompanhe seu zakat com facilidade',
            privacy: 'Política de privacidade',
            source: 'Código aberto',
            chrome: 'Extensão de horários de oração para Chrome'
        }
    }
};

export const isRtlLanguage = (language) => language === 'ar';

export const getTranslation = (language, key) => {
    const selected = translations[language] || translations.en;
    return key.split('.').reduce((value, part) => value?.[part], selected)
        || key.split('.').reduce((value, part) => value?.[part], translations.en)
        || key;
};
